<template>
    <div>
        <BreadCrumb class="bread" :breads="['监测柜管理','货柜管理']"></BreadCrumb>
        <div class="wrap">
            <div class="header">
                <span class="nameFt">货柜管理</span>
            </div>
            <div class="submit-form">
                <el-form :model="search" :inline="true" size="small" label-width="80px">
                    <div class="submit-form__search">
                        <el-form-item label="机器编号">
                            <el-input size="small" v-model="hard_number" suffix-icon="el-icon-search" readonly
                                      @focus="simplesetDialogSearchItem('hard_number')"></el-input>
                        </el-form-item>
                        <el-form-item label="补货状态">
                            <el-radio-group v-model="replenish">
                                <el-radio v-for="item in status" :label="item.value" :key="item.value">{{item.label}}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="大区">
                            <el-input size="small" v-model="area" suffix-icon="el-icon-search" readonly
                                      @focus="setDialogSearchItem('area')"></el-input>
                        </el-form-item>
                        <el-form-item label="区域">
                            <el-input size="small" v-model="region" suffix-icon="el-icon-search" readonly
                                      @focus="setDialogSearchItem('region')" :disabled="!this.area"></el-input>
                        </el-form-item>
                        <el-form-item label="点位">
                            <el-input size="small" v-model="point" suffix-icon="el-icon-search" readonly
                                      @focus="setDialogSearchItem('point')" :disabled="!this.region"></el-input>
                        </el-form-item>
                    </div>
                    <div class="submit-form__operate">
                        <el-form-item>
                            <el-button class="queryBtn" size="small" type="primary" @click="searchBtn('cl')">查询
                            </el-button>
                            <el-button class="queryBtn" size="small" type="primary" @click="resetBtn">重置</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="operate-con">
                <el-button class="queryBtn" size="small" type="primary" @click="addBtn"
                           v-show="$store.getters.authority({name:'cabinetManage',type:'add'})">新增
                </el-button>
            </div>
            <div class="table-con">
                <el-table :data="tableData" stripe style="width: 100%" id="table" :row-class-name="tableRowClassName">
                    <el-table-column prop="hard_number" label="机器编号" align="center">
                    </el-table-column>
                    <el-table-column prop="terminal_type" label="产品型号" align="center">
                    </el-table-column>
                    <el-table-column label="温湿度" width="100px" align="center">
                        <template slot-scope="scope">
                            <div class="temper">{{scope.row.humiture[0].humidity}}°C</div>
                            <div class="temper">{{scope.row.humiture[0].temperature}}%</div>
                            <div @click="drawLine(scope.row)">
                                <img class="icon-iconCodes" src="@/assets/images/common/humidity.png" alt="温湿度"
                                     ></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="network" label="网络状态" align="center">
                        <template slot-scope="scope">  
                             <div :class="scope.row.network == '离线' ? 'text-red' : 'tex-blue'">{{scope.row.network}}
                </div>
                       <!-- <div>:scope.row.network_status !== '在线' ? 'text-warning' }}</div>  -->
                        </template>   
                    </el-table-column>
                    <el-table-column prop="sale" label="今日销售" align="center">
                    </el-table-column>
                    <el-table-column prop="stock" label="库存" align="center">
                    </el-table-column>
                    <el-table-column prop="region" label="大区" align="center">
                    </el-table-column>
                    <el-table-column prop="sub_region" label="区域" align="center">
                    </el-table-column>
                    <el-table-column prop="region_point" label="点位" align="center">
                    </el-table-column>
                    <el-table-column prop="point_type" label="货柜位置" width="100px" align="center">
                        <template slot-scope="scope">
                            <div>
                                <img style="width: 25px;height: 25px;cursor:pointer;" src="@/assets/images/common/position.png" alt="温湿度"
                                     @click="showOpen(scope.row)">
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="update_at" label="更新时间" align="center">
                    </el-table-column>
                    <!--1.5-->
                    <el-table-column label="操作" align="center" width="320px" v-if="!printVisible">
                        <template slot-scope="scope">
                            <el-button size="small" type="text" @click="openVideoView(scope.row)">明细库存</el-button>
                            <el-button size="small" type="text" class="mr15" @click="exhibit(scope.row)">修改</el-button>
                            <el-button size="small" class="mr15" type="text" @click="exhibitImg(scope.row)">查看图片</el-button>
                            <el-button size="small" class="mr15" type="text" @click="toDetail(scope.row)">历史明细</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="paginationWrap">
                    <el-pagination @current-change="handleCurrentChange" :page-size="10" :current-page="paging"
                                   layout="total, prev, pager, next" :total="total">
                    </el-pagination>
                </div>
            </div>
             <cabinetechart ref='cabinetechart'></cabinetechart>
             <SimpleImageDialog ref='SimpleImageDialog'></SimpleImageDialog> 
        </div>
    
      <!-- 地图 -->
        <el-dialog
                :visible.sync="mapDialog"
                ref="dialog"
                width="37.5%"
                center>
            <div slot="footer" class="dialog-footer" style="margin-top: -24px;">
           <div id="Map"></div>
            </div>
        </el-dialog>
         <el-dialog :visible.sync="ImagedialogVisible" width="800px" title="库存查看">
              <div style="margin-bottom:20px;">现有总库存</div>
              <el-table :data="CData">
                    <el-table-column label="序号" align="center" type="index" :index="indexMethod"></el-table-column>
                         <el-table-column prop="name" label="商品名称" align="center">
                    </el-table-column>
                         <el-table-column prop="number" label="商品编号" align="center">
                    </el-table-column>
                         <el-table-column prop="region" label="图片" align="center">
                              <template slot-scope="scope">
                            <div>
                                <img style="width: 40px;height: 40px;" :src="scope.row.image">
                            </div>
                        </template>
                    </el-table-column>
                       <el-table-column prop="count" label="库存" align="center">
                             <template slot-scope="scope">
                              <div v-if="scope.row.count<=2" style="color:red;">{{scope.row.count}}</div>
                              <div v-else style="color:black;">{{scope.row.count}}</div>
                        </template>
                    </el-table-column>

              </el-table>
              <span slot="footer" class="dialog-footer">
               <el-button @click="ImagedialogVisible = false">取 消</el-button>
               <el-button type="primary" @click="ImagedialogVisible = false">确 定</el-button>
             </span>


        </el-dialog>


        <simple-double-dialog :show="dialogVisible" @close="closeSimpleDialog" :dialogData="dialogData"
                              :width="'500px'"></simple-double-dialog>
         
        <simple-find-dialog :show="simpledialogVisible" :dialogData="simpledialogData" @close="simplecloseSimpleDialog" :width="'500px'"></simple-find-dialog>   
    </div>
</template>

<script>
    import BreadCrumb from "@/components/BreadCrumb";
    import apis from "@/config/apis";
    import cabinetechart from "./cabinetechart";
    import SimpleDoubleDialog from "@/components/SimpleDoubleDialog";
    import SimpleFindDialog from "@/components/SimpleFindDialog";
    import SimpleImageDialog from "@/components/mengniu/SimpleImageDialog"
    import {
        terminalTypes , network_status
    } from "@/plugins/enum.js";
    import alert from "@/plugins/alert";

    export default {
        name: "CabinetMangement",
        data() {
            return {
                hard_number: '',
                hard_number_id:'',
                enlargeImg:'',
                imgDialogVisible:false,
                centerDialogVisible:false,
                ImagedialogVisible:false,
                mapDialog:false,
                line: {},
                terminal_type: {},
                point: {},
                point_type: {},
                replenish: '',
                imgData:[],
                CData:[],
                status: [{
                    value: false,
                    label: "全部"
                },
                    {
                        value: true,
                        label: "待补货"
                    }
                ],
                operationList: [{
                    value: "look",
                    label: "查看"
                },
                    {
                        value: "update",
                        label: "修改"
                    },
                    {
                        value: "detele",
                        label: "删除"
                    }
                ],
                typeOptions: terminalTypes,
                network:network_status, // 网络状态
                tableData: [],
                loading: false,
                area: '',
                area_id: '',
                region: '',
                point: '',
                region_id: [],
                sub_region_id: [],
                region_point_id: [],
                total: 1,
                paging: 1,
                XX_dialog: false,
                downData: {},
                reloadData: null,
                Showdialog: false,
                reload_dialog: false,
                caintechartShow: false,
                echart_dialog: false,
                loading: false,
                chart: null,
                downRow: null, //下载对象
                latModel: {
                    province: "", //省
                    city: "", //市
                    area: "", //区
                    address: "" //详细地址
                },
                dialogVisible: false,
                dialogData: {},
                simpledialogData: {},
                province_options: [],
                city_options: [],
                area_options: [],

                LatData: {}, //当前的货柜数据
                Lat_dialog: false, //经纬度 弹窗
                tempData: {},
                RemPageIndex: 1, //当前余数
                nowDialog: "", //现在打开的弹窗里的类型
                printVisible: false
            };
        },

        created() {
            let { query } = this.$route;
            this.hard_number = query.hard_number ? query.hard_number : "",
            this.replenish = query.replenish ? query.replenish : false;
            this.searchBtn();
        },
        mounted() {
        },
        methods: {
            /*search*/
            searchBtn(thatType='') {
                let params = {
                    tid: this.hard_number_id,
                    region_id: this.region_id,
                    sub_region_id: this.sub_region_id,
                    region_point_id: this.region_point_id,
                    replenish:this.replenish,
                    page_index: thatType === "cl" ? (this.paging = 1) : this.paging,
                }
                this.$axios.get(apis.stocklist, {params}).then(res => {
                    this.tableData = res.data.data;
                    this.total = res.data.pagination.total_count;
                })
            },

            /*重置 按钮*/
            resetBtn() {
                this.hard_number_id='';
                this.region_id = '';
                this.sub_region_id= '';
                this.region_point_id='';
                this.hard_number = '';
                this.point = '';
                this.region= '';
                this.area = '';
                this.replenish = false;
                this.searchBtn();
            },
            /*新增*/
            addBtn() {
                this.$router.push({
                    path: "inspectionUpdate"
                })
            },
            /*打印*/
            printBtn() {
                this.printVisible = true;
            },
            /*温湿度*/
            drawLine(row) {
                this.$refs.cabinetechart.show({
                    hard_number: row.hard_number
                });
            },
            //打开弹出选择配置
            setDialogSearchItem(type) {
                switch (type) {
                    case "hard_number":
                        this.dialogData = {
                            searchItems: [{
                                key: "hard_number",
                                label: "机器编号"
                            }],
                            searchTableItem: [{
                                key: "hard_number",
                                name: "机器编号"
                            }],
                            proxyLink: "bizhardnumber",
                            proxyType: "get"
                        };
                        break;
                    case "area":
                        this.dialogData = {
                            searchItems: [{
                                key: "name",
                                label: "大区名称"
                            },],
                            searchTableItem: [{
                                key: "name",
                                name: "大区名称"
                            }],
                            proxyLink: "region",
                            proxyType: "get"
                        };
                        break;
                    // case "point":
                    //     this.dialogData = {
                    //         searchItems: [{
                    //             key: "point_name",
                    //             label: "点位"
                    //         },
                    //             {
                    //                 key: "sub_id",
                    //                 value: this.ruleForm.area_name_id,
                    //                 hidden: true
                    //             }
                    //         ],
                    //         searchTableItem: [{
                    //             key: "point_name",
                    //             name: "点位名称"
                    //         }],
                    //         proxyLink: "point",
                    //         proxyType: "get"
                    //     };
                    //     break;
                    case "region":
                        this.dialogData = {
                            searchItems: [{
                                key: "sb_name",
                                label: "区域名称"
                            }, {
                                key: "rid",
                                value: this.region_id,
                                hidden: true
                            }],
                            searchTableItem: [{
                                key: "sb_name",
                                name: "区域名称"
                            }],
                            proxyLink: "area",
                            proxyType: "get"
                        };
                        break;
                    case "point":
                        this.dialogData = {
                            searchItems: [{
                                key: "point_name",
                                label: "点位类型"
                            },
                                {
                                    key: "sub_id",
                                    value: this.sub_region_id,
                                    hidden: true
                                }],
                            searchTableItem: [{
                                key: "point_name",
                                name: "点位类型"
                            }],
                            proxyLink: "point",
                            proxyType: "get"
                        };
                        break;
                }
                this.dialogVisible = true;
                this.nowDialog = type;
            },
            simplesetDialogSearchItem(type){
                switch (type) {
                    case "hard_number":
                        this.simpledialogData = {
                            searchItems: [{
                                key: "hard_number",
                                label: "机器编号"
                            }],
                            searchTableItem: [{
                                key: "hard_number",
                                name: "机器编号"
                            }],
                            proxyLink: "bizhardnumber",
                            proxyType: "get"
                        };
                        break;
                }
                 this.simpledialogVisible = true;
                this.nowDialog = type;
            },
            //分页-当前页
            handleCurrentChange(page) {
                this.search.page_index = page;
                this.searchBtn();
            },
            //关闭简单弹出窗口（选择）
            closeSimpleDialog(data) {
                switch (this.nowDialog) {
                    case "hard_number":
                         let h_data = [];
                        let h_name = [];
                        for (let obj in data) {
                            h_data.push(data[obj].id);
                            h_name.push(data[obj].hard_number);
                        }
                        this.hard_number_id = JSON.stringify(h_data);//传给后台id
                        this.hard_number = h_name;
                        break;
                    case "area":
                        let _data = [];
                        let _name = [];
                        for (let obj in data) {
                            _data.push(data[obj].id);
                            _name.push(data[obj].name);
                        }
                        this.region_id = JSON.stringify(_data);//传给后台id
                        this.area = _name;
                        break;
                    case "region":
                        let __data = [];
                        let __name = [];
                        for (let obj in data) {
                            __data.push(data[obj].id);
                            __name.push(data[obj].sb_name);
                        }
                        this.sub_region_id = JSON.stringify(__data);//传给后台id
                        this.region = __name;
                        break;
                    case "point":
                        let ___data = [];
                        let ___name = [];
                        for (let obj in data) {
                            ___data.push(data[obj].id);
                            ___name.push(data[obj].point_name);
                        }
                        this.region_point_id = JSON.stringify(___data);//传给后台id
                        this.point = ___name;
                        break;
                }
                this.dialogVisible = false;
            },
            simplecloseSimpleDialog(data){
               switch (this.nowDialog) {
                    case "hard_number":
                      this.hard_number_id = Number(data.id);
                      this.hard_number = data.hard_number;
                        break;
            }
            this.simpledialogVisible = false;
            },
            exhibit(row) {
                this.$router.push({
                    name: 'inspectionUpdate',
                    query: {
                        id: row.id,
                        hard_number: row.hard_number,
                        terminal_type: row.terminal_type,

                    }
                })
            },
            showImg(row){
                this.enlargeImg = row.image;
                this.imgDialogVisible = true;
            },
            exhibitImg(row) {
                this.$refs.SimpleImageDialog.show({
                    id: row.id
                });
            },
          
            showOpen(row){
                    this.mapDialog = true;
                        let lat= row.latitude;
                        let long = row.longitude;
                        let center = new qq.maps.LatLng(lat, long);
                        let map = new qq.maps.Map( document.getElementById("Map"), {
                            center: center,
                            zoom: 13
                        });
                        let marker = new qq.maps.Marker({
                            position: center,
                            map: map
                        });
            },
            toDetail(row){
                this.$router.push({
                    name:"inventorydetails",
                    query:{
                        d_id:row.id,
                        hard_number:row.hard_number,
                    }
                })
            },

            openVideoView(row) {
                this.ImagedialogVisible = true;
                let params = {
                    flag:'true',
                    
                }
                this.$axios.get(apis.stockdetail +row.id,{params}).then(res => {
                    if(res.data.code == 200){
                        this.CData = res.data.data;
                    }
                });
            },
            //打开历史库存
            openStockHistory() {
                this.$router.push({
                    name: 'stockHistory',
                })
            }
        },
        components: {
            BreadCrumb,
              cabinetechart,
            SimpleDoubleDialog,
            SimpleFindDialog,
            // SimplePrint,
            SimpleImageDialog,
            // cabinetechart
        }
    };
</script>

<style>
    .el-table .warning-row {
        background: #fdf6ec;
    }

    .el-table .error-row {
        background: #fef1f1;
    }
    .text-warning{
        color:red;
    }
    .tex-blue{
        color: #77bc1e;   
         }
</style>

<style lang="scss" scoped>
    .mr15 {
        margin-right: 15px;
    }

    .paginationWrap {
        padding: 10px 0;
        text-align: right;
    }

    .downCode {
        display: inline-block;
        padding: 0 6px;
        cursor: pointer;
    }

    .temper {
        width: 40px;
    }

    .icon-iconCodes {
        width: 26px;
        height: 26px;
        margin-top: -65px;
        margin-right: -20px;
        cursor: pointer;
        vertical-align: middle;
    }

    .icon-iconCode {
        width: 26px;
        height: 26px;
        vertical-align: middle;
    }

    /* 位置弹窗 */

    .reload_dialog {
        .lineItem {
            width: 102px;
        }

        .leftMrgin {
            margin-left: 10px;
        }

        .blockAddarea {
            display: block;
        }

        .btngroupCenter {
            margin: 0 auto;
            text-align: center;
            display: block;
        }
    }

    .smallSelect {
        width: 100px;
        margin-left: 10px;
    }

    /*弹窗*/

    .el-icon-download {
        border: 1px solid rgba(0, 0, 0, 0.2);
        padding: 6px;
        cursor: pointer;
    }

    .el-icon-warning {
        color: #e6a23c;
        font-size: 60px;
    }

    .borderGray {
        border: 1px solid rgba(0, 0, 0, 0.13);
    }

    .Main {
        text-align: center;

        .infoOne {
            font-size: 28px;
            line-height: normal;
        }

        .infoTwo {
            padding-top: 10px;
            font-size: 14px;
        }
    }

    .text-red {
        color:red;
    }
</style>

<style lang="scss">
    #Map{
        width:500px;
        height:400px;
    }
    .dialogMY {
        .el-dialog__body {
            padding: 20px 25px 25px;
        }
    }

    .blockAddarea {
        .el-form-item__content {
            display: block;
        }
    }
</style>
